import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';

import { createEffectFactory } from '@recruitee/ngrx';

import { OAuthCountersActions } from './o-auth-counters.store';
import { OAuthHttpClient } from '../../services/o-auth-http-client';

@Injectable({ providedIn: 'root' })
export class OAuthCountersEffects {
  public effect = createEffectFactory(OAuthCountersActions, this.actions$);

  public fetch$ = this.effect(OAuthCountersActions.fetch, () =>
    this.oAuthHttpClient.loadClientAuthCounters(),
  );

  constructor(
    private actions$: Actions,
    private oAuthHttpClient: OAuthHttpClient,
  ) {}
}
